import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import {
	RegisterUserRequestStatus,
	RegisterUserRequestStatusEvent,
} from '../register-user.component';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-register-user-confirmation',
	templateUrl: './register-user-confirmation.component.html',
	styleUrls: [
		'./register-user-confirmation.component.scss',
		'../../common/main.scss',
		'../register-user.component.scss',
	],
	imports: [MatIcon, MatButton],
})
export class RegisterUserConfirmationComponent implements OnInit {
	@Input()
	registerUserRequestStatusEvents!: Observable<RegisterUserRequestStatusEvent>;
	@Output() submitRegisterUserData = new EventEmitter();

	showLoading = false;
	showSuccess = false;
	showFailure = false;
	appSchemeUrl = 'accessplusregistrationscheme://';
	appOpenTimeout = 3000;

	registerUserRequestEvent?: RegisterUserRequestStatusEvent;

	constructor(
		private readonly router: Router,
		private readonly authService: AuthService,
		private readonly dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.registerUserRequestStatusEvents.subscribe((event) => {
			this.showLoading = false;
			this.showSuccess = false;
			this.showFailure = false;

			this.registerUserRequestEvent = event;

			switch (event.status) {
				case RegisterUserRequestStatus.loading:
					this.showLoading = true;
					break;
				case RegisterUserRequestStatus.success:
					this.showSuccess = true;
					break;
				case RegisterUserRequestStatus.failure:
					this.showFailure = true;
					break;
			}
		});
	}

	onSignInClicked(): void {
		this.router.navigate(['/login']);
	}

	onRetryClicked(): void {
		this.submitRegisterUserData.emit(undefined);
	}

	openAppOrStore() {
		const appId = 'uk.co.keyneticsltd.sentrikeyaccessplus'; // Access+ App ID
		let userAgent = navigator.userAgent || navigator.vendor;
		const isAndroid = userAgent.toLowerCase().indexOf('android') > -1;
		if (isAndroid) {
			window.location.href =
				'market://details?id=uk.co.keyneticsltd.sentrikeyaccessplus';
		} else {
			window.location.href = 'https://apps.apple.com/app/id1669803790';
		}
	}
}
